import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminRecommendations } from "../../lib/adminApi";

const ACTION_TONE = {
  push: { color: "#87A96B", label: "Push" },
  feature: { color: "#D4AF37", label: "Feature" },
  trial: { color: "#C17F59", label: "Trial" },
  watch: { color: "#5B7C99", label: "Watch" },
  replace: { color: "#A23B72", label: "Replace" },
};

export default function AdminRecommendations() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState("push");

  useEffect(() => { adminRecommendations().then(setData); }, []);

  if (!data) return <div className="p-10 text-white/40">Loading...</div>;

  return (
    <div className="px-5 md:px-10 py-8 max-w-7xl" data-testid="admin-recommendations">
      <header className="mb-6">
        <p className="overline text-[#C17F59] mb-2">Recommendations · explainable</p>
        <h1 className="font-display text-4xl">What to push, feature, trial, watch, replace.</h1>
        <p className="text-sm text-white/55 mt-2 max-w-2xl">Every recommendation shows why it's there and what risks remain. No black-box scoring.</p>
      </header>

      <div className="flex gap-1 mb-5 border-b border-white/8 overflow-x-auto no-scrollbar">
        {Object.entries(ACTION_TONE).map(([k, v]) => (
          <button key={k} onClick={() => setActive(k)}
                  className={`text-xs uppercase tracking-[0.22em] px-4 py-2 transition-colors ${
                    active === k ? "border-b-2" : "text-white/50 hover:text-white"
                  }`} style={active === k ? { color: v.color, borderColor: v.color } : {}}
                  data-testid={`rec-tab-${k}`}>
            {v.label} ({data.by_action[k]?.length || 0})
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {(data.by_action[active] || []).slice(0, 30).map((r) => {
          const tone = ACTION_TONE[r.action];
          return (
            <Link key={r.gin_id} to={`/admin/menu/${r.gin_id}`}
                  className="bg-[#15171A] border border-white/8 hover:border-white/25 p-5 transition-colors"
                  data-testid={`rec-${r.gin_id}`}>
              <div className="flex items-start justify-between mb-2">
                <div>
                  <p className="overline" style={{ color: tone.color }}>{tone.label}</p>
                  <h3 className="font-display text-2xl mt-1">{r.name}</h3>
                  <p className="text-[10px] uppercase tracking-[0.2em] text-white/40">{r.country} · ₹{r.price} · {r.views_14d} views</p>
                </div>
                <div className="text-right">
                  <p className="overline text-white/40">Score</p>
                  <p className="font-display text-3xl" style={{ color: tone.color }}>{r.score}</p>
                </div>
              </div>
              {r.why.length > 0 && (
                <div className="mt-3">
                  <p className="overline text-white/50 mb-1">Why</p>
                  <ul className="text-sm text-white/75 space-y-0.5">
                    {r.why.map((w, i) => <li key={i}>· {w}</li>)}
                  </ul>
                </div>
              )}
              {r.risk.length > 0 && (
                <div className="mt-3">
                  <p className="overline text-red-400/70 mb-1">Risk</p>
                  <ul className="text-sm text-white/55 space-y-0.5">
                    {r.risk.map((w, i) => <li key={i}>· {w}</li>)}
                  </ul>
                </div>
              )}
            </Link>
          );
        })}
        {(data.by_action[active] || []).length === 0 && (
          <p className="text-sm text-white/40 col-span-full">Nothing in this bucket yet.</p>
        )}
      </div>
    </div>
  );
}
